import '../static/styles.css';
import { c as cssModule0 } from "./styles.module.css_.module.D7vCQ6ZH.mjs";
const { "fieldbox": _0 } = cssModule0;
const label = `_label_f9250ab`;
const indicator = `_indicator_901f668`;
const invalid = `_invalid_926e8d9`;
const minimal = `_minimal_46a41fb`;
const _default = `_default_b6cd006`;
const icon = `_icon_b1dac48`;
const disabled = `_disabled_4caafbe`;
const checked = `_checked_e2be080`;
const neutral = `_neutral_dd296ba`;
const checkbox = `_checkbox_55c0f6f ${_0}`;
const checkboxStyles = { label, indicator, invalid, minimal, "default": _default, icon, disabled, checked, neutral, checkbox };
export {
  checkboxStyles as c
};
//# sourceMappingURL=styles.module.CUKyFbde.mjs.map
